import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_be73014c from 'nuxt_plugin_plugin_be73014c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_debug_5a737512 from 'nuxt_plugin_debug_5a737512' // Source: ./fathom/debug.js (mode: 'all')
import nuxt_plugin_fathom_20304e40 from 'nuxt_plugin_fathom_20304e40' // Source: ./fathom/middleware/fathom.js (mode: 'all')
import nuxt_plugin_fathomclient_0083db6d from 'nuxt_plugin_fathomclient_0083db6d' // Source: ./fathom/plugins/fathom.client.js (mode: 'client')
import nuxt_plugin_gtm_a4787774 from 'nuxt_plugin_gtm_a4787774' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_plugin_791fc702 from 'nuxt_plugin_plugin_791fc702' // Source: ./nuxt-speedkit/plugin.js (mode: 'all')
import nuxt_plugin_nuxtgooglemaps_65996532 from 'nuxt_plugin_nuxtgooglemaps_65996532' // Source: ./nuxt-google-maps.js (mode: 'all')
import nuxt_plugin_nuxtcookiecontrol_48b413a8 from 'nuxt_plugin_nuxtcookiecontrol_48b413a8' // Source: ./nuxt-cookie-control.js (mode: 'all')
import nuxt_plugin_templatesplugind431ce70_9ec41092 from 'nuxt_plugin_templatesplugind431ce70_9ec41092' // Source: ./templates.plugin.d431ce70.js (mode: 'all')
import nuxt_plugin_axios_a60d3d20 from 'nuxt_plugin_axios_a60d3d20' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_3e6e1acb from 'nuxt_plugin_pluginutils_3e6e1acb' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_11532156 from 'nuxt_plugin_pluginrouting_11532156' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_111b39d9 from 'nuxt_plugin_pluginmain_111b39d9' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gsapModule_987edc3e from 'nuxt_plugin_gsapModule_987edc3e' // Source: ./gsapModule.js (mode: 'all')
import nuxt_plugin_workbox_54118ae8 from 'nuxt_plugin_workbox_54118ae8' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_46e3359f from 'nuxt_plugin_metaplugin_46e3359f' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_image_cfff432a from 'nuxt_plugin_image_cfff432a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_richtextrenderer_983253f6 from 'nuxt_plugin_richtextrenderer_983253f6' // Source: ../../../plugins/rich-text-renderer.ts (mode: 'all')
import nuxt_plugin_injections_193ea90a from 'nuxt_plugin_injections_193ea90a' // Source: ../../../plugins/injections.ts (mode: 'all')
import nuxt_plugin_pwaupdateclient_d7827174 from 'nuxt_plugin_pwaupdateclient_d7827174' // Source: ../../../plugins/pwa-update.client.ts (mode: 'client')
import nuxt_plugin_youtubeliteclient_34dda922 from 'nuxt_plugin_youtubeliteclient_34dda922' // Source: ../../../plugins/youtube-lite.client.ts (mode: 'client')
import nuxt_plugin_vimeoliteclient_53e61d61 from 'nuxt_plugin_vimeoliteclient_53e61d61' // Source: ../../../plugins/vimeo-lite.client.ts (mode: 'client')
import nuxt_plugin_routechange_290a6e4a from 'nuxt_plugin_routechange_290a6e4a' // Source: ../../../plugins/routechange.ts (mode: 'all')
import nuxt_plugin_vueawesomeswiperclient_06965e93 from 'nuxt_plugin_vueawesomeswiperclient_06965e93' // Source: ../../../plugins/vue-awesome-swiper.client.ts (mode: 'client')
import nuxt_plugin_vueobservevisibilityclient_42d89bd8 from 'nuxt_plugin_vueobservevisibilityclient_42d89bd8' // Source: ../../../plugins/vue-observe-visibility.client.ts (mode: 'client')
import nuxt_plugin_previewclient_5fee67b4 from 'nuxt_plugin_previewclient_5fee67b4' // Source: ../../../plugins/preview.client.ts (mode: 'client')
import nuxt_plugin_vuejsmodalclient_24d6c0cc from 'nuxt_plugin_vuejsmodalclient_24d6c0cc' // Source: ../../../plugins/vue-js-modal.client.ts (mode: 'client')
import nuxt_plugin_superscript_3c025b46 from 'nuxt_plugin_superscript_3c025b46' // Source: ../../../plugins/superscript.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Echt","titleTemplate":"%s | Echt","htmlAttrs":{"lang":"de-CH"},"meta":[{"hid":"charset","charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"author","name":"author","content":"Code Crush GmbH"},{"hid":"publisher","name":"publisher","content":"Code Crush GmbH"},{"hid":"copyright","name":"copyright","content":"Copyright © 2022 Code Crush GmbH"},{"hid":"company","name":"company","content":"Echt"},{"hid":"description","name":"description","content":""},{"hid":"robots","name":"robots","content":"index"},{"hid":"author","name":"author","content":"https:\u002F\u002Fecht.ch\u002F"},{"hid":"publisher","name":"publisher","content":"https:\u002F\u002Fecht.ch\u002F"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Echt"},{"hid":"theme-color","name":"theme-color","content":"#theme-color"},{"hid":"og:title","property":"og:title","content":"Echt"},{"hid":"og:description","property":"og:description","content":"Neuromarketing im digitalen Zeitalter"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fecht.ch\u002F"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fecht.ch\u002Fog_image.png"},{"hid":"og:image:width","property":"og:image:width","content":"1300"},{"hid":"og:image:height","property":"og:image:height","content":"600"},{"hid":"og:locale","property":"og:locale","content":"de_CH"},{"hid":"og:site_name","property":"og:site_name","content":"Echt"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@user"},{"hid":"twitter:creator","name":"twitter:creator","content":"@user"},{"hid":"twitter:title","name":"twitter:title","content":"Echt"},{"hid":"twitter:description","name":"twitter:description","content":"Neuromarketing im digitalen Zeitalter"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fecht.ch\u002Fog_image.png"},{"hid":"twitter:image:width","name":"twitter:image:width","content":"1300"},{"hid":"twitter:image:height","name":"twitter:image:height","content":"600"}],"link":[{"rel":"icon","href":"\u002Ffavicon.ico","sizes":"any"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ficon.svg"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png"},{"rel":"preconnect","href":"\u002F\u002Fa.storyblok.com"}],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NGBTR6H')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NGBTR6H&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_be73014c === 'function') {
    await nuxt_plugin_plugin_be73014c(app.context, inject)
  }

  if (typeof nuxt_plugin_debug_5a737512 === 'function') {
    await nuxt_plugin_debug_5a737512(app.context, inject)
  }

  if (typeof nuxt_plugin_fathom_20304e40 === 'function') {
    await nuxt_plugin_fathom_20304e40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fathomclient_0083db6d === 'function') {
    await nuxt_plugin_fathomclient_0083db6d(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_a4787774 === 'function') {
    await nuxt_plugin_gtm_a4787774(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_791fc702 === 'function') {
    await nuxt_plugin_plugin_791fc702(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtgooglemaps_65996532 === 'function') {
    await nuxt_plugin_nuxtgooglemaps_65996532(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcookiecontrol_48b413a8 === 'function') {
    await nuxt_plugin_nuxtcookiecontrol_48b413a8(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugind431ce70_9ec41092 === 'function') {
    await nuxt_plugin_templatesplugind431ce70_9ec41092(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_a60d3d20 === 'function') {
    await nuxt_plugin_axios_a60d3d20(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3e6e1acb === 'function') {
    await nuxt_plugin_pluginutils_3e6e1acb(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_11532156 === 'function') {
    await nuxt_plugin_pluginrouting_11532156(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_111b39d9 === 'function') {
    await nuxt_plugin_pluginmain_111b39d9(app.context, inject)
  }

  if (typeof nuxt_plugin_gsapModule_987edc3e === 'function') {
    await nuxt_plugin_gsapModule_987edc3e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_54118ae8 === 'function') {
    await nuxt_plugin_workbox_54118ae8(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_46e3359f === 'function') {
    await nuxt_plugin_metaplugin_46e3359f(app.context, inject)
  }

  if (typeof nuxt_plugin_image_cfff432a === 'function') {
    await nuxt_plugin_image_cfff432a(app.context, inject)
  }

  if (typeof nuxt_plugin_richtextrenderer_983253f6 === 'function') {
    await nuxt_plugin_richtextrenderer_983253f6(app.context, inject)
  }

  if (typeof nuxt_plugin_injections_193ea90a === 'function') {
    await nuxt_plugin_injections_193ea90a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pwaupdateclient_d7827174 === 'function') {
    await nuxt_plugin_pwaupdateclient_d7827174(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_youtubeliteclient_34dda922 === 'function') {
    await nuxt_plugin_youtubeliteclient_34dda922(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vimeoliteclient_53e61d61 === 'function') {
    await nuxt_plugin_vimeoliteclient_53e61d61(app.context, inject)
  }

  if (typeof nuxt_plugin_routechange_290a6e4a === 'function') {
    await nuxt_plugin_routechange_290a6e4a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiperclient_06965e93 === 'function') {
    await nuxt_plugin_vueawesomeswiperclient_06965e93(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibilityclient_42d89bd8 === 'function') {
    await nuxt_plugin_vueobservevisibilityclient_42d89bd8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_previewclient_5fee67b4 === 'function') {
    await nuxt_plugin_previewclient_5fee67b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsmodalclient_24d6c0cc === 'function') {
    await nuxt_plugin_vuejsmodalclient_24d6c0cc(app.context, inject)
  }

  if (typeof nuxt_plugin_superscript_3c025b46 === 'function') {
    await nuxt_plugin_superscript_3c025b46(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
